
export enum Quadrant {
  Do = 'DO',             // Q1: Urgent + Important
  Schedule = 'SCHEDULE', // Q2: Not Urgent + Important
  Delegate = 'DELEGATE', // Q3: Urgent + Not Important
  Eliminate = 'ELIMINATE'// Q4: Not Urgent + Not Important
}

export enum TaskStatus {
  Todo = 'TODO',
  Doing = 'DOING',
  Done = 'DONE'
}

export interface Task {
  id: string;
  title: string;
  description?: string;
  quadrant: Quadrant;
  status: TaskStatus;
  createdAt: number;
  uid: string;
  completedAt?: number; // Timestamp when task was marked DONE
  timeSpent?: number;   // Total focus time in seconds
  isRoutine?: boolean;  // If true, this task resets daily
}

export interface FocusSettings {
  workDuration: number;       // in minutes
  shortBreakDuration: number; // in minutes
  longBreakDuration: number;  // in minutes
  blockedSites?: string[];    // List of domains to block during focus
}

export interface UserProfile {
  uid: string;
  email: string | null;
  displayName: string | null;
  isPro: boolean;
  photoURL: string | null;
  focusSettings?: FocusSettings;
  showWelcomeModal?: boolean; // Controls the onboarding modal
  // Gamification
  xp: number;
  level: number;
  theme?: 'light' | 'dark' | 'midnight' | 'paper';
}

export interface AppState {
  user: UserProfile | null;
  tasks: Task[];
  loading: boolean;
  view: 'matrix' | 'kanban' | 'settings' | 'focus' | 'analytics' | 'daily';
  activeTaskId?: string; // ID of the task currently in Focus Mode
  showMagicSort?: boolean; // Controls the visibility of the AI modal
}

export interface AIMagicResult {
  title: string;
  quadrant: Quadrant;
  reason: string;
}

// --- NEW PERSISTENT TIMER TYPES ---
export type TimerMode = 'work' | 'shortBreak' | 'longBreak';

export interface TimerState {
  status: 'running' | 'paused' | 'idle' | 'finished';
  mode: TimerMode;
  endTime: number | null;      // Timestamp when timer will end (if running)
  remainingSeconds: number;    // Seconds left (if paused or idle)
  totalDuration: number;       // Total seconds of the current session
  taskId: string | null;       // ID of the task being focused
  accumulatedTime: number;     // How many seconds actually spent working (for XP)
  lastUpdated: number;         // Timestamp of last state change
}
